<template>
  <main class="outlook-content main-content wide">
    <div class="wrap">
      <sidebar-left />

      <section class="outlook-main-block">
        <h1>{{ pageData.pageTitle }}</h1>
        <div
          v-if="pageData.pageDescription !== ''"
          v-dompurify-html="pageData.pageDescription"
          class="lead-text"
        />

        <magazine-block
          v-if="pageData.issues"
          :issues="pageData.issues"
        />

        <section class="advertise-block">
          <h2 class="title">{{ pageData.advertise.title }}</h2>
          <div
            v-if="pageData.advertise.description !== ''"
            v-dompurify-html="pageData.advertise.description"
            class="description"
          />

          <div
            v-if="Object.keys(team).length"
            class="team-block"
          >
            <ad
              v-for="(ad, key) in team"
              :key="key"
              :country-code="key"
              :ad="ad"
            />
          </div>
        </section>
      </section>
    </div>
    <small-loader />
  </main>
</template>

<script>
  import Sidebar from 'components/Sidebar/Sidebar'
  import { mapState } from 'vuex'
  import get from 'lodash-es/get'

  export default {
    components: {
      'sidebar-left': Sidebar,
      SmallLoader: () => import(/* webpackChunkName: "small-loader" */ 'components/SmallLoader'),
      MagazineBlock: () => import(/* webpackChunkName: "magazine" */ 'containers/Pages/Outlook/MagazineBlock'),
      Ad: () => import(/* webpackChunkName: "magazine" */ 'containers/Pages/Outlook/Ad')
    },
    computed: {
      ...mapState('outlook', [
        'pageData'
      ]),
      team () {
        return get(this.pageData, 'advertise.countries', {})
      }
    },
    mounted () {
      this.getOutlookIssue()
    },
    methods: {
      getOutlookIssue () {
        const params = this.checkForParams()
        if (params && this.pageData && this.pageData.issues) {
          if (this.checkIfIssueExist(params.month, params.year)) {
            this.$store.commit('outlook/setActiveYear', params.year)
            this.$store.commit('outlook/setActiveMonth', params.month)
          }
        }
      },

      checkForParams () {
        const uri = window.location.search.substring(1)
        const params = new URLSearchParams(uri)
        const year = params.get("year")
        const month = typeof params.get("month") === 'string' ? params.get("month").toLowerCase() : undefined
        if (!!year && !!month) {
          return { year, month }
        }
        return undefined
      },

      checkIfIssueExist (month, year) {
        if (year && month) {
          return !!this.pageData.issues[`${year}`] && !!this.pageData.issues[`${year}`][`${month}`]
        }
        return false
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .outlook-content {
    padding: 26px 0 0;

    @include bp-tablet-only {
      padding: 44px 0 82px;
    }

    @include bp-mf-desktop {
      padding: 40px 0 72px;
    }

    .wrap {
      display: flex;
      flex-direction: column;
      @include clearfix();

      @include bp-mf-desktop {
        display: block;
      }
    }
  }

  .outlook-main-block {
    position: relative;
    order: 1;
    padding: 0 23px;
    margin-bottom: 20px;

    @include bp-tablet-only {
      padding: 0 26px;
    }

    @include bp-mf-desktop {
      float: left;
      vertical-align: top;
      padding: 0;
      width: 66%;
    }

    h1 {
      color: $grey-default;
      font-size: em(32);
      font-weight: 300;
      letter-spacing: 0;
      line-height: 44px;
      margin: 0 0 11px;
    }

    .lead-text {

      /deep/ p {
        color: $grey-default;
        font-size: em(14);
        letter-spacing: 0;
        line-height: 22px;
        margin: 0 0 6px;
      }
    }
  }

  .advertise-block {

    .title {
      color: $grey-default;
      font-size: em(24);
      font-weight: 500;
      letter-spacing: 0;
      line-height: 28px;
      margin: 0 0 11px;
    }

    .description {
      color: $grey-default;
      font-size: em(16);
      letter-spacing: 0;
      line-height: 22px;
      margin: 0;

      /deep/ p {
        margin: 0 0 6px;
      }
    }
  }

  .team-block {
    flex-direction: column;
    justify-content: space-between;
    align-content: center;
    margin-top: 10px;

    @include bp-mf-tablet {
      display: flex;
      justify-content: space-between;
      width: 100%;
      flex-direction: row;
      margin-top: 20px;
    }
  }
</style>
